import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader';

const Disclaimer: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Disclaimer</h1>
            <p className="text-gray-600">Last Updated: August 31, 2025</p>
          </div>

          <div className="prose prose-lg max-w-none">
            <p className="mb-6">
              This Disclaimer governs your use of the RealEstart.io website and all associated services, including flashcards, practice tests, and study materials (collectively, the "Services"). RealEstart.io is owned and operated by Signal Cloud LLC.
            </p>

            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">1. No Guarantee of Results & Study Aid Only</h2>
                <p className="text-gray-700 leading-relaxed">
                  RealEstart.io is designed and provided as a supplementary study aid and educational tool only. We explicitly do not guarantee, represent, or warrant that your use of our Services will result in you passing any real estate licensing examination, including but not limited to the Georgia Real Estate Salesperson exam. The content is for informational and practice purposes only. Your success on any licensing exam is dependent on your individual effort, preparation, and understanding of the material.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">2. Not a Licensed Educational Provider</h2>
                <p className="text-gray-700 leading-relaxed">
                  RealEstart.io and Signal Cloud LLC are not a licensed or accredited real estate school, a provider of any official pre-licensing course, or an authorized testing center. In the state of Georgia, you are required to complete a 75-hour pre-licensing course from a licensed school in order to be eligible to sit for the real estate licensing exam. The Services provided by RealEstart.io are not a substitute for this mandatory requirement.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">3. No Use of Actual Exam Questions</h2>
                <p className="text-gray-700 leading-relaxed">
                  We affirm that the content provided within the Services, including all practice questions, quizzes, and flashcards, is the original intellectual property of Signal Cloud LLC. None of the content is derived from, based on, or intended to replicate questions from any official state, federal, or third-party real estate licensing examination. Our materials are developed to test and reinforce general real estate principles and knowledge, not to provide advance access to or to replicate specific test questions. Any resemblance to actual exam questions is purely coincidental. The use of our Services will not violate any Georgia or federal laws regarding cheating or unfair means of passing a licensing exam.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">4. Assumption of Risk</h2>
                <p className="text-gray-700 leading-relaxed">
                  By using RealEstart.io, you acknowledge and agree that you are doing so at your own risk. You assume all responsibility and liability for any damages or losses that may arise from the use of our Services, including but not limited to financial loss, failure to pass an exam, or any other professional or personal harm.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">5. Limitation of Liability and Indemnification</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  To the fullest extent permitted by law, Signal Cloud LLC, its owners, employees, contractors, and affiliates shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses, resulting from:
                </p>
                <ul className="list-disc list-inside ml-6 mb-4 space-y-2 text-gray-700">
                  <li>Your access to or use of or inability to access or use the Services;</li>
                  <li>Any conduct or content of any third party on the Services;</li>
                  <li>Any content obtained from the Services; and</li>
                  <li>Unauthorized access, use, or alteration of your transmissions or content.</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You agree to defend, indemnify, and hold harmless Signal Cloud LLC and its owners, employees, and affiliates from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from:
                </p>
                <ul className="list-disc list-inside ml-6 mb-4 space-y-2 text-gray-700">
                  <li>Your use of and access to the Services;</li>
                  <li>Your violation of any term of these documents;</li>
                  <li>Your violation of any third-party right, including without limitation any intellectual property, privacy, or publicity right; or</li>
                  <li>Any claim that your use of the Services caused damage to a third party.</li>
                </ul>
                <p className="text-gray-700 leading-relaxed">
                  This indemnification obligation will survive the termination of your use of the Services and the expiration of this Disclaimer.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">6. Not Professional or Legal Advice</h2>
                <p className="text-gray-700 leading-relaxed">
                  The content on RealEstart.io is for informational purposes only. It is not professional or legal advice. You should consult with a qualified real estate professional, educational provider, or attorney for advice tailored to your specific situation.
                </p>
              </div>
            </div>

            <div className="mt-12 text-center">
              <Link 
                to="/" 
                className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
